export const FederalState: {
    BW: 'BW',
    BY: 'BY',
    BE: 'BE',
    BB: 'BB',
    HB: 'HB',
    HE: 'HE',
    HH: 'HH',
    MV: 'MV',
    NI: 'NI',
    NW: 'NW',
    RP: 'RP',
    SL: 'SL',
    SN: 'SN',
    ST: 'ST',
    SH: 'SH',
    TH: 'TH',
} = {
    BW: 'BW',
    BY: 'BY',
    BE: 'BE',
    BB: 'BB',
    HB: 'HB',
    HE: 'HE',
    HH: 'HH',
    MV: 'MV',
    NI: 'NI',
    NW: 'NW',
    RP: 'RP',
    SL: 'SL',
    SN: 'SN',
    ST: 'ST',
    SH: 'SH',
    TH: 'TH',
};

export type FederalState = (typeof FederalState)[keyof typeof FederalState]
